// Toast helpers over the Vuex `notificator` module (spec §12).
import { errorMessage } from './resource';

function dispatch(vm, text, color, time) {
  if (vm && vm.$store && typeof vm.$store.dispatch === 'function') {
    vm.$store.dispatch('addNotification', { text, time, color });
  }
}

export function notifySuccess(vm, text) {
  dispatch(vm, text, 'success', 5);
}

export function notifyError(vm, errorOrText, fallback) {
  dispatch(vm, errorMessage(errorOrText, fallback), 'danger', 6);
}

export function notifyInfo(vm, text) {
  dispatch(vm, text, 'info', 6);
}
